import { TextDocument, Position, CompletionList, Diagnostic, Hover } from 'vscode-languageserver-types';

import { LanguageSettings } from './gcLanguageTypes';
import GreyCatParser from './services/gc-parser';
import GreyCatCompletion from './services/gc-completion';
import GreyCatValidation from './services/gc-validation';
import GreyCatHover from './services/gc-hover';
import { ParseResult, GreyCatType, GreyCatFunction, addTypes, addFunctions } from '@greycat/lang';
export { ParseResult, GreyCatType, GreyCatFunction } from '@greycat/lang';
export * from './gcLanguageTypes';

export interface LanguageService {
  doParse(document: TextDocument): ParseResult;
  doValidation(document: TextDocument, gcr: ParseResult, settings?: LanguageSettings): Diagnostic[];
  doComplete(document: TextDocument, position: Position, gcr: ParseResult): CompletionList;
  doHover(document: TextDocument, position: Position, gcr: ParseResult): Hover | null;
  addTypes(types: GreyCatType[]): void;
  addFunctions(functions: GreyCatFunction[]): void;
}

function createFacade(parser: GreyCatParser, completion: GreyCatCompletion, validation: GreyCatValidation, hover: GreyCatHover) {
  return {
    doParse: parser.parse.bind(parser),
    doValidation: validation.doValidation.bind(validation),
    doComplete: completion.doComplete.bind(completion),
    doHover: hover.doHover.bind(hover),
    addTypes,
    addFunctions,
  };
}

export function getGreyCatLanguageService(): LanguageService {
  return createFacade(new GreyCatParser(), new GreyCatCompletion(), new GreyCatValidation(), new GreyCatHover());
}
